import { signal, type Signal } from '@preact/signals';
import type { MessageEntry, WidgetConfig, ControllerKind } from './types';

export interface ChatSessionState {
  isOpen: Signal<boolean>;
  config: Signal<WidgetConfig | null>;
  token: Signal<string>;
  messages: Signal<MessageEntry[]>;
  conversationId: Signal<string | null>;
  isLoading: Signal<boolean>;
  isSending: Signal<boolean>;
  error: Signal<string | null>;
  currentStreamContent: Signal<string>;
  lastAssistantMessageId: Signal<string | null>;
  /** Current conversation controller — determines poll cadence and UI hints. */
  controller: Signal<ControllerKind>;
}

export function createChatSessionState(): ChatSessionState {
  return {
    isOpen: signal(false),
    config: signal<WidgetConfig | null>(null),
    token: signal(''),
    messages: signal<MessageEntry[]>([]),
    conversationId: signal<string | null>(null),
    isLoading: signal(true),
    isSending: signal(false),
    error: signal<string | null>(null),
    currentStreamContent: signal(''),
    lastAssistantMessageId: signal<string | null>(null),
    controller: signal<ControllerKind>('ai'),
  };
}
